<template>
  <div v-if="realty.visible" class="realty-card">
    <img class="image" :src="realty.preview" />
    <div class="wrapper-main-info">
      <div>
        <div v-if="realty" class="title">
          {{ translateRealty(realty.name) }}
        </div>

        <div class="meta-info">
          <div class="name-param">
            {{ $t('City') }}
          </div>
          <div class="value-param">
            {{ $realty(realty.city) }}
          </div>
        </div>
        <div class="meta-info">
          <div class="name-param">
            {{ $t('Country') }}
          </div>
          <div class="value-param">
            {{ $ct(realty.country) }}
          </div>
        </div>
      </div>
    </div>
    <div class="action">
      <ui-button
        class="btn"
        :label="$t('open')"
        color="gray"
        @click="openRealty"
      />
    </div>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, ref} from 'vue';
import {useRouter} from 'vue-router';
import {useUserStore} from '~/modules/User/user.store';
import {useLocale} from '@/plugins/Localization';
export default defineComponent({
  name: 'RealtyCard',
  components: {},
  props: {
    realty: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const locale = useLocale();
    const router = useRouter();
    const translateRealty = (key: string) => {
      return locale.getRealty(key);
    };
    const openRealty = () => {
      console.debug(
        props.realty.apartments.length,
        props.realty.houses?.length,
      );
      if (props.realty.houses?.length) {
        router.push({
          query: {
            real_estate_with_houses: props.realty.uuid,
            secondaryPathName: translateRealty(props.realty.name),
            nameRC: props.realty.name,
          },
        });
      } else if (props.realty.apartments.length) {
        router.push({
          query: {
            real_estate_with_apartments: props.realty.uuid,
            secondaryPathName: translateRealty(props.realty.name),
            nameRC: props.realty.name,
          },
        });
      }
    };
    return {translateRealty, openRealty};
  },
});
</script>

<style lang="scss" scoped>
.realty-card {
  width: 264px;
  height: 312px;
  padding: 18px;
  border-radius: 16px;
  border: 1px solid var(--white-theme-white-400, #e1e5f0);
  background: var(--white-theme-white-200, #f6f8fd);
  display: flex;
  flex-direction: column;

  &.preload {
    .image {
      background: linear-gradient(
        107.15deg,
        #192734 36.98%,
        #273b4f 49.48%,
        #192734 61.46%
      );
      animation: 1.5s shine linear infinite;
      background-size: 200% 100%;
    }

    .wrapper-main-info {
      .title {
        background: linear-gradient(
          107.15deg,
          #192734 36.98%,
          #273b4f 49.48%,
          #192734 61.46%
        );
        border-radius: 4px;
        width: 100%;
        height: 16px;
        background-size: 200% 100%;
        animation: 1.5s shine linear infinite;
      }

      .meta-info {
        margin-top: 8px;
        background: linear-gradient(
          107.15deg,
          #192734 36.98%,
          #273b4f 49.48%,
          #192734 61.46%
        );
        animation: 1.5s shine linear infinite;
        background-size: 200% 100%;
        border-radius: 4px;
        background-color: var(--bg-secondary);
        width: 100%;
        height: 16px;
      }
    }
  }

  .image {
    width: 100%;
    height: 142px;
    border-radius: 8px;
    background-size: cover;
    background-position: center;
    transition: all 0.2s ease;
    margin-bottom: 16px;
    object-fit: cover;
  }

  .action {
    margin-top: auto;
    padding-top: 16px;
  }

  .info-btn {
    width: 24px;
    min-width: 24px;
    height: 24px;
    cursor: pointer;

    svg {
      width: 100%;
      height: 100%;
      transition: all 0.2s ease-in-out;
      fill: #7f97aa;
    }

    &:hover {
      svg {
        fill: #fff;
      }
    }
  }

  .wrapper-main-info {
    width: 100%;
    display: flex;
    justify-content: space-between;

    div {
      text-align: left;
    }

    .title {
      color: var(--white-theme-black-100, #3d424a);
      font-family: Segoe UI;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      letter-spacing: 0.32px;
      align-items: center;
      position: relative;
      display: flex;
      white-space: nowrap;
      // &:after {
      //   position: absolute;
      //   right: 0;
      //   height: 100%;
      //   width: 50px;
      //   background: linear-gradient(
      //       90deg,
      //       transparent 0,
      //       var(--bg-quinary) 100%
      //   );
      //   content: '';
      // }
    }

    .meta-info {
      display: flex;
      margin-top: 4px;

      .name-param {
        margin-right: 24px;
        width: 64px;
        height: 16px;
        color: var(--white-theme-gray-200, #839aaf);
        font-family: Segoe UI;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      .value-param {
        color: var(--white-theme-black-200, #64686e);
        font-family: Segoe UI;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }
  .btn {
    width: 100%;
  }
}
</style>
